var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, eventDateRange } from '@shapeable/utils';
import { CalendarIconGlyph, LocationIconGlyph } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { IconTextValue } from '../elements/icon-text-value';
var cls = classNames('event-date-location');
export var EventDateLocationDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var IconAndDateStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconDateLocation: styled(IconTextValue)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconAndDateStyles)
};
export var EventDateLocation = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var startDate = entity.startDate,
    endDate = entity.endDate,
    location = entity.location;
  var t = useLang();
  var hasLocation = !!(location === null || location === void 0 ? void 0 : location.name) && !!(location === null || location === void 0 ? void 0 : location.country.name);
  var dates = eventDateRange(startDate, endDate);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, !!dates && React.createElement(My.IconDateLocation, {
    iconComponent: CalendarIconGlyph,
    color: 'strong',
    iconSize: 23
  }, dates), hasLocation && React.createElement(My.IconDateLocation, {
    iconComponent: LocationIconGlyph,
    color: 'strong',
    iconSize: 24
  }, t(location === null || location === void 0 ? void 0 : location.name), ", ", t((_a = location === null || location === void 0 ? void 0 : location.country) === null || _a === void 0 ? void 0 : _a.name)), children);
};
EventDateLocation.defaultProps = EventDateLocationDefaultProps;
EventDateLocation.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;